import { ReviewsSectionRoot } from 'features/Home/components/ReviewsSection/ReviewsSection.styles'
import { styled } from 'stitches.config'

export const ReviewsRoot = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  backgroundColor: '$primary-800',
  width: '100%',
  borderTop: 0,
  borderBottom: '12px solid transparent',
  borderImage: 'url(/assets/pattern-footer-border-mobile.svg) 30',

  '@bp2': {
    borderImage: 'url(/assets/pattern-footer-border-desktop.svg) 30',
  },

  '&': {
    [`${ReviewsSectionRoot}`]: {
      width: '100%',
    },
  },
})
